import React from 'react';
import Grid   from '@material-ui/core/Grid';
import Paper  from '@material-ui/core/Paper';

import Tabs                from '../../common-components/Tabs';   // Tabs component
import UserStationsMap     from './UserStationsMap';
import HeatMap             from './HeatMap';            
import PortfolioInfo       from './DashboardPortfolioInfo';  
import SatisticInfo        from './SatisticInfo';
import WeatherInfoTable    from './WeatherInfoTable';

const StatisticsAndWeatherInfo = () => (
  <Grid container spacing={8}>
    <Grid item lg={6} md={12} sm={12} xs={12}>
      <Paper elevation={2}>
        <UserStationsMap />
      </Paper>
    </Grid>

    <Grid item lg={6} md={12} sm={12} xs={12}>
        <Tabs>
          <div label="Heat Map">
            <Paper elevation={2} style={{ padding: 0 }}>
                <PortfolioInfo />
                <HeatMap />
            </Paper>
          </div>
          <div label="Realtime Monitoring">
            <Paper elevation={2} style={{ padding: 0 }}>
            <div className="infoWrapper">
              <div className="infoWrapperInner">
                <SatisticInfo />
              </div>
              <div className="infoWrapperInner">
                <WeatherInfoTable />
              </div>
            </div>
            </Paper>
          </div>
        </Tabs>
    </Grid>
  </Grid>
);

export default StatisticsAndWeatherInfo;
